module.exports = __webpack_public_path__ + "static/media/coingossip-popularity.3a4accce.png";